import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const RCSelect = listeners["select"] || function() {};
  const RCSelectAll = listeners["select-all"] || function() {};
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "试题题干",
      prop: "questionTitle",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate"
    },
    {
      label: "试题分类",
      prop: "questionCategoryName"
    },
    {
      label: "试题类型",
      prop: "examQuestionTypeName"
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      onSelect={RCSelect}
      onSelectAll={RCSelectAll}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
